
import Vue from "vue";
export default Vue.extend({
	props: {
		grow: Boolean
	},
	computed: {
		style() {
			return {
				flexGrow: "1"
			};
		}
	}
});
